import { render, staticRenderFns } from "./Billings.vue?vue&type=template&id=2db7b8f9&scoped=true&"
import script from "../js/billings.js?vue&type=script&lang=js&"
export * from "../js/billings.js?vue&type=script&lang=js&"
import style0 from "./Billings.vue?vue&type=style&index=0&id=2db7b8f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db7b8f9",
  null
  
)

export default component.exports